@if (googleMapsLoaded) {
  <google-map
    #googleMap="googleMap"
    [ngClass]="{'chart-container-edit-mode' : !machine.isLocationAvailable()}"
    [options]="mapOptions"
    [mapTypeId]="mapType"
    [zoom]="zoomLvl"
    height="100%"
    width="100%">
    <map-marker [options]="marker.get('options')"
      #mapMarker="mapMarker"
      (mapClick)="onOpenInfoWindow(mapMarker, infoWindow)"
    [position]="marker.get('position')"></map-marker>
    <map-info-window #infoWindow="mapInfoWindow" (closeclick)="onCloseInfoWindow()">
      <div class="p-1" style="min-width: 160px;">
        <h6 class="h6 mb-2 truncate" [innerText]="marker.getTitle() || ''"></h6>
        <div class="map-info-address mb-2" [innerText]="machineAddress()"></div>
        <button type="button"
          (click)="redirectToGoogleMaps()"
          class="btn btn-sm btn-outline-primary btn-block">
          <i class="fa-solid fa-route"></i>
          <span translate>Show on maps</span>
        </button>
      </div>
    </map-info-window>
  </google-map>
} @else {
  <div class="d-flex align-items-center justify-content-center h-100">
    <div>
      <span class="fa-solid fa-spinner fa-spin mr-2"></span>
      <span translate>Loading Map ...</span>
    </div>
  </div>
}

